<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

/**
 * Announces a navigation to screen readers.
 *
 * A single-page app changes the screen without a page load, so assistive technology hears
 * nothing — the operator pressed a link and, as far as the reader is concerned, nothing
 * happened. This region speaks the new title after each navigation settles.
 */
const route = useRoute()
const message = ref('')

watch(
  () => route.fullPath,
  () => {
    const title = typeof route.meta.title === 'string' ? route.meta.title : 'Page'
    // Cleared and re-set on a tick so an identical title is still announced.
    message.value = ''
    setTimeout(() => {
      message.value = `${title} loaded`
    }, 50)
  },
)
</script>

<template>
  <div
    class="sr-only"
    role="status"
    aria-live="polite"
    aria-atomic="true"
  >
    {{ message }}
  </div>
</template>
